<template>
  <div ref="surveyInfo">
    <div v-if="!loading.all" class="row align-items-center justify-content-start w-100">
        <div class="d-flex align-items-center col-md-12">
          <feather-icon
            class="icon-hover mr-2"
            icon="ChevronLeftIcon"
            size="24"
            @click="returnSurveys()"
          />
          <h5 class="mb-0" v-if="form.name"><strong>{{ form.name }}</strong></h5>
          <h5 class="mb-0" v-else><strong>Nueva encuesta</strong></h5>
          <b-form-checkbox
              switch
              class="checkbox-switch switch-survey ml-2"
              v-model="form.is_active">
              <span class="personalize-status">{{ !!form.is_active ? 'Activo' : 'Inactivo' }}</span>
          </b-form-checkbox>
        </div> 
        <div class="padding-form-survey col-md-12">
          <hr>
          <form-render :form.sync="form" :fields="fields" @send="updateOrCreate" ref="formRenderNewSurvey" :key="keyFormRender">
            <template #line>
              <div>
                <div class="d-flex justify-content-end align-items-center more-fields">
                    <span class="icon-hover" @click="handleViewFields()">
                        {{ showFields ? 'Ver menos' : 'Ver más' }}
                        <feather-icon
                            class="mr-50 ml-50"
                            :icon="showFields ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                            size="16"
                        />
                    </span>
                </div>
                <hr>
              </div>
            </template>
            <template #date>
              <div class="row">
                  <div class="col-md-12">
                    <label title="Fecha de vigencia" class="label-form">
                      <span>Fecha de vigencia</span>
                      <span class="text-danger"> *</span>
                    </label>
                    <field-datepicker
                      :value.sync="form.date_range"
                      :range="true"
                      :showCalendarIcon="true"
                      :requiredDateRange="error_date"
                      :change="changeDate"
                    />
                    <div :class="error_date ? 'invalid-feedback d-block' : 'invalid-feedback'">
                      Este campo es
                      requerido </div>
                  </div>
              </div>
            </template>
            <template #questions>
              <div
                v-for="(question, index) in form.questions"
                :key="question.id"
                class="container-question mb-2"
              >
                <div class="header-container-question row align-items-stretch">
                  <div class="col-md-5 field-question">
                    <field-input
                      v-model="question.title"
                      :placeholder="'Escriba aquí pregunta ' + (index + 1) + ' |'"
                      :onFocus="selectAllText"
                    ></field-input>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">
                    <b-form-checkbox
                      switch
                      class="checkbox-switch switch-survey required-question"
                      v-model="question.is_required"
                    >
                      <span class="personalize-status">Obligatoria</span>
                    </b-form-checkbox>
                  </div>
                  <div class="col-md-3 type-question">
                    <v-select
                      v-model="question.type"
                      placeholder="Seleccione el tipo de pregunta"
                      label="text"
                      :options="optionsTypeQuestions"
                      :clearable="false"
                      @input="changeTypeQuestion(question.id ,question.type)"
                    />
                  </div>
                  <div
                    v-b-tooltip.hover 
                    title="Duplicar pregunta"
                    class="icon-copy-question col-md-1 d-flex justify-content-center align-items-center"
                    @click="duplicateQuestion(question.id)"
                  >
                    <feather-icon class="icon-hover" icon="CopyIcon" size="20" />
                  </div>
                  <div
                    v-b-tooltip.hover 
                    title="Eliminar pregunta"
                    class="icon-trash-question col-md-1 d-flex justify-content-center align-items-center"
                    @click="deleteQuestion(question.id)"
                  >
                    <feather-icon class="icon-hover" icon="TrashIcon" size="20" />
                  </div>
                </div>
                <div>
                  <field-textarea
                    class="textarea-support-text" 
                    :value.sync="question.description" 
                    name="question-open" 
                    placeholder="Ingrese texto de apoyo de la pregunta (opcional)"/>
                </div>
                <div v-if="[1, 2].includes(question.type.id)">
                  <div class="d-flex align-items-center ml-2" v-for="(option, indexOption) in question.options" :key="indexOption">
                    <feather-icon
                      :icon="question.type.id === 2 ? 'CircleIcon' : 'SquareIcon'"
                      size="24"
                    />
                    <field-input
                        v-model="option.value"
                        :placeholder="'Escriba la opción ' + (indexOption + 1)"
                        class="field-value-option"
                        :onFocus="selectAllText"
                    >
                    </field-input>
                    <feather-icon
                      v-b-tooltip.hover 
                      title="Eliminar opción"
                      v-if="question.options.length > 1"
                      icon="XIcon"
                      size="24"
                      class="icon-hover"
                      @click="removeOption(question.id, option.id)"
                    />
                  </div>
                  <div class="d-flex align-items-center ml-2 mt-50 mb-50 new-option">
                    <feather-icon
                      :icon="question.type.id === 2 ? 'CircleIcon' : 'SquareIcon'"
                      size="24"
                      @click="addNewOption(question.id)"
                    />
                    <p @click="addNewOption(question.id)">Nueva opción</p>
                  </div>
                </div>
                <div v-if="[3].includes(question.type.id)" class="ml-2">
                  <div class="d-flex range-question align-items-center">
                    <span class="mr-50">De</span>
                    <v-select
                      v-model="question.range.start"
                      label="text"
                      :options="optionsScaleInitial"
                      :clearable="false"
                      @input="changeRangeQuestion($event, question.id, 'start')"
                    />
                    <span class="mr-50 ml-50">a</span>
                    <v-select
                      v-model="question.range.end"
                      label="text"
                      :options="optionsScaleEnd"
                      :clearable="false"
                      @input="changeRangeQuestion($event, question.id, 'end')"
                    />
                  </div>
                  <div class="mt-1">
                    <p class="d-flex align-items-center">{{ question.range.start }}
                      <field-input
                        v-model="question.range.text_start"
                        placeholder="Etiqueta (opcional)"
                        class="field-value-range"
                      />
                    </p>
                    <p class="d-flex align-items-center">{{ question.range.end }}
                      <field-input
                        v-model="question.range.text_end"
                        placeholder="Etiqueta (opcional)"
                        class="field-value-range"
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <span v-b-tooltip.hover title="Puedes crear hasta un máximo de 10 preguntas">
                <b-button
                  variant="outline-light"
                  class="custom-button-questions"
                  @click="form.questions.length === 5 ? confirmAddQuestion() : addQuestion()"
                  :disabled="form.questions.length > 9"
                    
                >
                  <feather-icon icon="PlusIcon" size="24" />
                </b-button>
                </span>
              </div>
            </template>
          </form-render>
          <div class="d-flex justify-content-end mt-2">
            <b-button @click="validateForm" :disabled="loading.saved || form.block_edit_survey" variant="warning">
              <span>{{acceptText}}</span>
            </b-button>
          </div>
        </div>
    </div>
    <div v-else class="center-spinner mb-2">
        <b-spinner />
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import { format } from 'date-fns'
export default {
  props: ['data', 'listCategories'],
  components: {vSelect},
  data () {
    return {
      form: {
        questions: []
      },
      acceptText: 'Crear',
      company: {},
      today : new Date(),
      fields: [],
      loading: {
        saved: false, 
        all: false
      },
      optionsCountries: [],
      optionsScaleInitial: ['0', '1'],
      optionsScaleEnd: ['2', '3', '4', '5', '6', '7', '8', '9', '10'],
      optionsTypeQuestions: [
        { id: 2, text: 'Opción múltiple', name: 'multiple'},
        { id: 1, text: 'Casillas', name: 'Casillas'},
        { id: 3, text: 'Escala lineal', name: 'Escala'},
        { id: 4, text: 'Abierta', name: 'Abierta'}
      ],
      optionsType: [
        { id: 'only_sellers', text: 'Ids de seller'},
        { id: 'only_marketplaces', text: 'Ids de marketplaces'},
        { id: 'only_sellers_by_marketplaces', text: 'Sellers por ids de marketplaces'}
      ],
      optionsExcludeType: [
        { id: 'all_companies', text: 'Ids de empresas'},
        { id: 'sellers_by_marketplaces', text: 'Sellers por ids de marketplaces'},
        { id: 'all_marketplaces_sellers', text: 'Todos los sellers de marketplaces'}
      ],
      optionsCategory: [],
      optionsAccount: [
        {id: 'distribution', text: 'Distribución', name: 'distribucion'},
        {id: 'gateway', text: 'Pasarela', name: 'pasarela' }
      ],
      optionsBilling: [{id: false, text: 'Notificar sólo a usuarios facturación directa'}],
      keyFormRender: 0,
      baseService: new BaseServices(this),
      deleteShipperFromArray: {
        click: false
      },
      indexShipper: null,
      CONDITIONS: Object.freeze({
        CREATE: 'create',
        EDIT: 'edit'
      }),
      error_date: false,
      showFields: true
    }
  },
  watch: {
    mySession () {
      if (this.mySession.id) this.setInitialData()
    },
    carriers () {
      this.setCarriers()
    },
    countries () {
      this.setCountries()
    },
    data () { 
      this.setSurvey()
    },
    survey (value) {
      this.loading.all = false
      this.setForm(value)
      this.changeCountry('country', this.form.country, true)
      this.changeType('company_type', this.form.company_type, true)
      this.changeExcludeType('exclude_type', this.form.exclude_type, true)
    },
    listCategories () {
      this.setCategories()
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      organizations: 'getOrganizationsGlobal',
      carriers: 'getCarriersNotifications',
      countries: 'getCountries',
      survey: 'getSurvey'
    })
  },
  mounted () {
    this.getAllInitialData()
  },
  methods: {
    getAllInitialData () {
      if (this.mySession.id) this.setInitialData()
    },
    setInitialData () {
      this.setCountries()
      this.setFields()
      this.setCarriers()
      this.setSurvey()
      this.setCategories()
    },
    setForm (value) {
      this.form = {
        ...value,
        category: value.category_id ? this.listCategories.find(category => category.id === value.category_id) : null,
        carriers: value.filters?.carriers ? this.carriers.filter(option => value.filters.carriers.includes(option.code)) : null,
        country: value.filters?.country_id ? this.optionsCountries.find(option => option.id === value.filters.country_id) : null,
        contract_type: value.filters?.contract_type ? this.optionsAccount.find(option => option.name === value.filters.contract_type) : null,
        company_type: value.filters?.company_type ? this.setValueInFilterByTypeKey(value.filters?.company_type, this.optionsType) : null,
        exclude_type: value.exclude_type ? this.setValueInFilterByTypeKey(value.exclude_type, this.optionsExcludeType) : null,
        direct_billing: value.filters?.direct_billing,
        include_companies_id: value.filters?.company_type ? this.setValueInFilterByTypeValue(value.filters.company_type) : null,
        exclude_companies_id: value.exclude_type && Object.keys(value.exclude_type)[0] !== 'all_marketplaces_sellers' ? this.setValueInFilterByTypeValue(value.exclude_type) : null,
        date_range: {
          start: new Date(`${value.start_date}T00:00:00`),
          end: new Date(`${value.end_date}T00:00:00`)
        },
        questions: value.questions ? this.formattedQuestions(value.questions) : []
      } 
    },
    formattedQuestions (questions) {
      return questions.map(question => {
        const formattedType = this.optionsTypeQuestions.find(option => option.id === question.type.id)
        return {
          ...question,
          type: formattedType || question.type
        }
      })
    },
    setValueInFilterByTypeKey (typeFilter, options) {
      const selectedKey = Object.keys(typeFilter)[0]
      const selectedOption = options.find(option => option.id === selectedKey)
      return selectedOption
    },
    setValueInFilterByTypeValue (typeFilter) {
      return Object.values(typeFilter)[0].join(',') 
    },
    setSurvey () {
      this.acceptText = !!this.data.id ? 'Guardar cambios' : 'Crear'
      this.fields = this.fields.filter(el => !['include_companies_id', 'exclude_companies_id'].includes(el.name))
      this.setSelectOptions('carriers', { options: this.carriers })
      if (!!this.data.id) {
        const queryParams = {}
        const params = {id: this.data.id}
        this.loading.all = true
        this.$store.dispatch('fetchService', { name: 'getSurvey', queryParams, params})
      } 
      else {
        this.addQuestion()
        this.form.is_active = true
      }
    },
    setCarriers () {
      if (this.carriers && !!this.carriers.length) {
        this.setSelectOptions('carriers', { options: this.carriers })
        this.loading.saved = false
      }
    },
    setCategories () {
      if (this.listCategories && !!this.listCategories.length) {
        this.setSelectOptions('category', { options: this.listCategories })
      }
    },
    setFields () {
      this.fields = [
        { fieldType: 'FieldSelect', label: 'País', name: 'country', containerClass: 'col-md-3 container-info', validation: 'required', options: this.optionsCountries, change: this.changeCountry, disabled: false},
        { fieldType: 'FieldSelect', label: 'Categoría', name: 'category', containerClass: 'col-md-3 container-info', clearable: true,  validation: 'required', options: this.optionsCategory},
        { name: 'date', useSlot: true, containerClass: 'col-md-3 container-info'},
        { fieldType: 'FieldSelect', label: 'Tipo de empresa', name: 'company_type', containerClass: 'col-md-3 container-info', clearable: true,  validation: '', options: this.optionsType, change: this.changeType, tooltip: { text: 'Deje en blanco para aplicar a todos.' }},
        { fieldType: 'FieldSelect', label: 'Tipo de contrato', name: 'contract_type', containerClass: 'col-md-3 container-info', clearable: true,  validation: '', options: this.optionsAccount, tooltip: { text: 'Deje en blanco para aplicar a todos.' }},
        { fieldType: 'FieldSelect', label: 'Ids a excluir', name: 'exclude_type', containerClass: 'col-md-6 container-info', clearable: true,  validation: '', options: this.optionsExcludeType, change: this.changeExcludeType},
        { fieldType: 'FieldSelect', label: 'Limitar couriers', useLabel: true, name: 'carriers', containerClass: 'col-md-6 container-info', multiple: true, useSkeleton: false, tooltip: { text: 'Deje en blanco para aplicar a todos.' }},
        { fieldType: 'FieldCheckbox', name: 'direct_billing', label: '', containerClass: 'col-md-6 d-flex align-items-center', align: 'h', options: this.optionsBilling, validation: ''},
        { name: 'line', useSlot: true, containerClass: 'container-info col-12' },
        { fieldType: 'FieldInput', label: 'Título', name: 'name', containerClass: 'col-md-9 container-info', validation: 'required'},
        { fieldType: 'FieldTextarea', label: 'Descripción', name: 'description', containerClass: 'col-md-9 container-info', validation: 'required', placeholder: 'Ingrese breve descripción o introducción'},
        { name: 'questions', useSlot: true, containerClass: 'container-info col-md-9'}
      ]
      this.indexCarrier = this.fields.find(item => item.name === 'carriers')
      this.indexCountry = this.fields.find(item => item.name === 'country')
    },
    setCountries () {
      if (this.countries && !!this.countries.length) {
        const countriesFormatter = this.countries.map(country => {
          return {
            id: country.id, 
            text: country.text, 
            code: country.code 
          }
        })
        countriesFormatter.unshift({ id: '*', text: 'Todos', code: '*' })
        this.optionsCountries = countriesFormatter
      }
      
    },
    changeDate (name, value) {
      this.error_date = !value?.start && !value?.end
    },
    validateForm () {
      this.error_date = !this.form.date_range?.start && !this.form.date_range?.end
      this.$refs.formRenderNewSurvey.checkForm()
    },
    changeType (name, value, notClean) {
      this.fields = this.fields.filter(el => !['include_companies_id'].includes(el.name))
      if (value && value.id) {
        const index = this.fields.findIndex(el => el.name === 'company_type')
        const myFields = {
          only_sellers: { fieldType: 'FieldTextarea', label: 'Ids de empresas numéricas separadas por coma (,) y sin espacios', name: 'include_companies_id', containerClass: 'col-md-12 container-info', allowNumbersAndCommas: true},
          only_marketplaces: { fieldType: 'FieldTextarea', label: 'Ids de marketplaces numéricas separadas por coma (,) y sin espacios', name: 'include_companies_id', containerClass: 'col-md-12 container-info', allowNumbersAndCommas: true},
          only_sellers_by_marketplaces: { fieldType: 'FieldTextarea', label: 'Ids de marketplaces numéricas separadas por coma (,) y sin espacios', name: 'include_companies_id', containerClass: 'col-md-12 container-info', allowNumbersAndCommas: true}
        }
        this.fields.splice(index + 1, 0, myFields[value.id])
      } 
      if (!notClean) this.form.include_companies_id = null
      this.keyFormRender++
    },
    changeExcludeType (name, value, notClean) {
      this.fields = this.fields.filter(el => !['exclude_companies_id'].includes(el.name))
      if (value && value.id) {
        const index = this.fields.findIndex(el => el.name === 'exclude_type')
        const myFields = {
          all_companies: { fieldType: 'FieldTextarea', label: 'Ids de empresas numéricas separadas por coma (,) y sin espacios', name: 'exclude_companies_id', containerClass: 'col-md-12 container-info', allowNumbersAndCommas: true},
          sellers_by_marketplaces: { fieldType: 'FieldTextarea', label: 'Ids de marketplaces numéricas separadas por coma (,) y sin espacios', name: 'exclude_companies_id', containerClass: 'col-md-12 container-info', allowNumbersAndCommas: true}
        }
        if (myFields[value.id]) {
          this.fields.splice(index + 1, 0, myFields[value.id])
        }
      }
      if (!notClean) this.form.exclude_companies_id = null
      this.keyFormRender++
    },
    setSelectOptions (name, { options }) {
      const index = this.fields.findIndex(el => el.name === name)
      if (index !== -1) {
        this.fields[index].options = options
        this.keyFormRender++
      }
    },
    changeCountry (name, value, notClean) {
      const originalCarriers = this.setSelectOptions('carriers', { options: this.carriers })
      if (!notClean) this.form.carriers = null
      if (value !== null) {
        if (value.id !== '*') {
          const filterCarrierByCountry = this.carriers.filter(item => {
            return item.country_id === value.id
          })
          this.setSelectOptions('carriers', { options: filterCarrierByCountry })
        } else {
          return originalCarriers
        }
      } else {
        return originalCarriers
      } 
    },
    handleViewFields () {
      this.showFields = !this.showFields
      const fields = ['name', 'description', 'questions']
      fields.forEach((el) => {
        const index = this.fields.findIndex((field) => field.name === el)
        this.fields[index].containerClass = this.showFields ? 'col-md-9 container-info animation' : 'animation hide-fields-survey'
      })
    },
    returnSurveys () {
      this.$emit('returnSurveys', {list: true, survey: false, resultsGraph: false})
    },
    confirmAddQuestion () {
      this.$confirm(
        this.$t('Lo recomendado para una encuesta <strong>son menos de</strong> 5 preguntas.'), 
        () => this.addQuestion(), '¿Está seguro que desea agregar una nueva pregunta?', 
        'Confirmar', 
        'Cancelar',
        true, 
        null, 
        null, 
        null, 
        null, 
        null, 
        'btn btn-customyesno-success btn-customyesno-success-bold'
      )
    },
    addQuestion() {
      const newQuestion = {
        id: uuidv4(),
        title: '',
        is_required: true,
        type: this.optionsTypeQuestions[0],
        options: [
          {id: uuidv4(), value: 'Opción 1'}
        ]
      }
      if (this.form?.id) newQuestion.deleteIdQuestion = true
      this.form.questions.push(newQuestion)
      this.keyFormRender++
    },
    duplicateQuestion(id) {
      if (this.form.questions.length < 10) {
        const index = this.form.questions.findIndex((question) => question.id === id)
        if (index !== -1) {
          const questionToDuplicate = this.form.questions[index]
          const duplicatedQuestion = _.cloneDeep(questionToDuplicate)
          duplicatedQuestion.id = uuidv4()
          if (this.form?.id) duplicatedQuestion.deleteIdQuestion = true
          this.form.questions.splice(index + 1, 0, duplicatedQuestion)
          this.keyFormRender++
        }
      }
    },
    deleteQuestion(id) {
      if (this.form.questions.length > 1) {
        const index = this.form.questions.findIndex((question) => question.id === id)
        if (index !== -1) {
          this.form.questions.splice(index, 1)
          this.keyFormRender++
        }
      }
    },
    addNewOption(questionId) {
      const question = this.form.questions.find(question => question.id === questionId)
      const newOptionNumber = question.options.length + 1
      question.options.push({
        id: uuidv4(),
        value: `Opción ${newOptionNumber}`,
        deleteIdOption: true
      })
      this.keyFormRender++
    },
    removeOption(questionId, optionId) {
      const question = this.form.questions.find(question => question.id === questionId)
      question.options = question.options.filter(option => option.id !== optionId)
      this.keyFormRender++
    },
    changeTypeQuestion(id, newType) {
      const question = this.form.questions.find(question => question.id === id)
      if (!question) return

      const typeConfig = {
        1: {
          keepOptions: true,
          range: null
        },
        2: {
          keepOptions: true,
          range: null
        },
        3: {
          keepOptions: false,
          range: { start: '1', end: '5' }
        },
        4: {
          keepOptions: false,
          range: null
        }
      }

      const config = typeConfig[newType.id] || { keepOptions: false, range: null }
      question.type = newType

      if (config.keepOptions) {
        if (!question.options) {
          this.$set(question, 'options', [{ id: uuidv4(), value: 'Opción 1' }])
        }
      } else {
        this.$delete(question, 'options')
      }
      if (config.range) {
        this.$set(question, 'range', config.range)
      } else {
        this.$delete(question, 'range')
      }
      this.keyFormRender++
    },
    changeRangeQuestion (value, questionId, type) {
      const question = this.form.questions.find(question => question.id === questionId)
      question.range[type] = value
      this.keyFormRender++
    },
    selectAllText(event) {
      const input = event.target
      if (input) {
        input.select()
      }
    },
    cleanObject (obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) => value !== undefined)
      )
    },
    transformOptions (question) {
      return question.options.map((option) => {
        const baseOptions = {
          value: option.value
        }
        if (this.form?.id && !question.deleteIdQuestion && !option.deleteIdOption) baseOptions.id = option.id
        return baseOptions
      })
    },
    transformQuestion (questions) {
      return questions.map((question) => {
        const baseQuestion = {
          id: this.form?.id && !question.deleteIdQuestion ? question.id : undefined,
          title: question.title || '',
          description: question.description || '',
          is_required: question.is_required,
          type: {
            id: question.type.id,
            name: question.type.name
          },
          options: question.options ? this.transformOptions(question) : undefined,
          range: question.range || undefined
        }
        return this.cleanObject(baseQuestion)
      })
    },
    updateOrCreate () {
      if (this.error_date) {
        return
      }
      this.loading.saved = true
      const queryParams = {
        name: this.form.name,
        description: this.form.description,
        category_id: this.form.category?.id,
        is_active: this.form.is_active,
        start_date: format(new Date(this.form.date_range.start), 'yyyy-MM-dd'),
        end_date: format(new Date(this.form.date_range.end), 'yyyy-MM-dd'),
        questions: this.transformQuestion(this.form.questions),
        filters: {
          country_id: this.form.country.id,
          contract_type: this.form.contract_type?.name || null,
          carriers: this.form.carriers && this.form.carriers.length > 0 ? this.codesCarriers(this.form.carriers) : null,
          company_type: this.form.company_type && this.form.include_companies_id ? this.transformData('company_type', this.form) : null,
          direct_billing: !!this.form.direct_billing || null 
        },
        exclude_type: this.form.exclude_type && (this.form.exclude_companies_id || this.form.exclude_type?.id === 'all_marketplaces_sellers') ? this.transformData('exclude_type', this.form) : null
      }
      const cleanedQueryParams = this.cleanNullValues(queryParams)
      const params = this.form?.id ? {id: this.form?.id} : {}
      this.$store.dispatch('fetchService', { 
        name: this.form?.id ? 'putSurvey' : 'postSurvey', 
        queryParams: cleanedQueryParams, 
        params, 
        onSuccess: (resp) => this.successSurvey(resp), 
        onError: (e) => this.errorSurvey(e),
        hideAlert: true
      })
    },
    cleanNullValues (queryParams) {
      return {
        ...Object.fromEntries(
          Object.entries(queryParams).filter(([_, value]) => value !== null)
        ),
        filters: Object.fromEntries(
          Object.entries(queryParams.filters || {}).filter(([_, value]) => value !== null)
        )
      }
    },
    codesCarriers (carriers) {
      return carriers.map(carrier => carrier.code)
    },
    transformData(type, form) {
      if (type === 'company_type') {
        return {
          [form.company_type.id]: this.parseIds(form.include_companies_id)
        }
      }
      if (type === 'exclude_type') {
        return {
          [form.exclude_type.id]: form.exclude_type.id === 'all_marketplaces_sellers' ? true : this.parseIds(form.exclude_companies_id)
        }
      }
    },
    parseIds(ids) {
      return ids.split(',').map(id => id.trim())
    },
    successSurvey (resp) {
      this.$emit('refreshTable')
      this.$newSuccess(`Encuesta ${this.form?.id ? 'editada' : 'cargada'} con éxito!`, 'Ahora puedes verlo reflejado en la plataforma.')
      this.acceptText = 'Guardar cambios'
      this.setForm(resp.data)
      this.loading.saved = false
    },
    errorSurvey (e) {
      this.$newError(`Ocurrio un error al ${this.form?.id ? 'editar' : 'crear'} la encuesta.`, e.message, 'medium')
      this.loading.saved = false
    }
  }
}
</script>
<style>
.switch-survey
  .custom-control-label {
  margin-bottom: 0 !important;
}
.switch-survey 
  .custom-control-input:checked ~ .custom-control-label::before,
  .custom-control-input:active ~ .custom-control-label::before {
  border-color: #1E8E3E;
  background-color: #1E8E3E;
}
.switch-survey
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before,
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #1f9d57a8 !important;
}
.required-question{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.padding-form-survey {
  padding: 1rem 5rem;
}
.icon-hover:hover {
  cursor: pointer;
}
.more-fields {
  color: #165191;
}

.animation {
  transition: all 0.3s ease-in-out;
  opacity: 1;
  transform: scale(1);
  height: auto;
  overflow: hidden;
}

.animation.hide-fields-survey {
  opacity: 0;
  transform: scale(0.9);
  height: 0; 
  visibility: hidden; 
  pointer-events: none; 
}
.container-question {
  border: 1px solid #d8d6de;
  border-radius: 5px;
}
.header-container-question {
  margin: 0;
  border-bottom: 1px solid #b9b9c76b;
}
.type-question {
  border-right: 1px solid #b9b9c76b;
  border-left: 1px solid #b9b9c76b;
}
.type-question .vs__dropdown-menu, .range-question .vs__dropdown-menu{
    top: 2.5rem !important;
}
.field-question {
  padding: 0;
  border-right: 1px solid #b9b9c76b;
}
.field-question input, .type-question .vs__dropdown-toggle, .field-value-option input, .textarea-support-text textarea, .field-value-range input{
  border: none;
}
.textarea-support-text .form-control:focus:valid,.form-control:focus.is-valid {
    box-shadow: none;
}
.field-question input::placeholder {
  color: #044389;
}
.icon-copy-question {
  border-right: 1px solid #b9b9c76b;
  color: #165191;
}
.icon-trash-question {
  color: #ED5565;
}
.custom-button-questions {
  padding: 0.4rem !important;
  border-radius: 5px !important;
}
.field-value-option {
  width: 80%;
}
.new-option p {
  margin: 0;
  margin: 0.438rem 1rem;
  color: #5C5C5C;
}
.new-option p:hover {
  border-bottom: 1px solid #ebe9f1;
}
.btn-customyesno-success-bold {
  font-weight: bold;
}
.center-spinner {
  display: flex;
  justify-content: center;
}
@media (max-width: 768px) {
  .icon-copy-question, .icon-trash-question {
    margin-bottom: 1rem;
  }
}
</style>